import React, { useState } from "react";
import {
  DialogContent,
  Card,
  DialogActions,
  Button,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  CardContent,
} from "@material-ui/core";
import Colors from "shared/color";
import CustomInput from "components/custom/CustomInput";
import { toastSuccess, toastWarning } from "shared/utils";
import { paymentReverseApi } from "shared/api";

const TCell = (props) => {
  return (
    <TableCell
      style={{
        border: "none",
        fontSize: "0.8125rem",
        padding: " 3px",
        ...props.style,
      }}
    >
      {props.children}
    </TableCell>
  );
};


export const PaymentReverse = ({ handleClose, data }) => {
  
  const [reverseAmount, setReverseAmount] = useState(parseFloat(data["payment_amount"] - data["extra_payment_amount"]).toFixed(2));
  const reverseMappingHandaler = async (e) => {
    e.preventDefault();

    let reqData = {
      user_reference_number: data["user_reference_number"],
      payment_reference_number: data["payment_reference_number"],
      payment_request_reason: data["payment_request_reason"],
      payment_amount: data["payment_amount"],
      reverse_amount: reverseAmount,
      payment_receipt_mode: data["payment_receipt_mode"],
      payment_receipt_date: data["payment_receipt_date"],
      
    };

    if( data?.payment_receipt_source === "AUTO_DEBIT"){
      reqData.payment_receipt_source = data["payment_receipt_source"]
    }

    try {
      const res = await paymentReverseApi(reqData);
      if (res.success) {
        toastSuccess(res.message);
    
      } else {
        toastWarning(res.message);
      }
      handleClose(false);
      setTimeout(() => {
        document.location.reload();
      }, 2000);
    } catch (error) {
      handleClose(false);
    }
  };

  return (
    <>
      <DialogContent
        dividers={false}
        style={{
          backgroundColor: Colors["lighterPurple"],
          fontSize: "0.8125rem",
          // minWidth: "40vw",
        }}
      >
        <div className="flex-spacing" style={{ margin: "1rem 0px" }}>
          <Card>
            <CardContent>
              <TableContainer>
                <Table size="small" aria-label="simple table">
                  <TableBody>
                  <tr style={{width:'100%',float:'left'}}>
                    <TCell style={{width:'50%'}}>Reverse Amount</TCell>
                    <TCell>
                      <CustomInput
                        style={{
                          width: "100%",
                        }}
                        type="number"
                        textFiledStyle={{ width: "100%" }}
                        value={reverseAmount}
                        onChange={(e) => setReverseAmount(e.target.value)}
                        placeholder="Reverse Amount"
                      />
                    </TCell>
                    </tr>  
                    {
                      data?.payment_request_reason === "DEACTIVATE_LOAN" && data?.payment_receipt_mode !== "PROMOTIONAL" ?
                      <tr style={{width:'100%',float:'left'}}>
                            
                              <p style={{paddingTop:'12px',fontWeight:'600',color:'orange'}}>
                                Warning *: This Payment is may be mapped with PROMOTIONAL Payment.
                              </p>
                            
                      </tr>
                    : null
                    }
                    
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={reverseMappingHandaler}
          color="primary"
          variant="contained"
          className="shadow-none common_kissht_btn"
          type="submit"
          disabled={!reverseAmount}
        >
          Submit
        </Button>
        <Button
          onClick={() => handleClose(false)}
          variant="contained"
          className="shadow-none common_kissht_btn"
          type="submit"
          //   disabled={isSubmitting || !isValid}
        >
          Close
        </Button>
      </DialogActions>
    </>
  );
};
